(() => {
  if (window.swTradeshowGate) { window.swTradeshowGate.init(document); return; }
  let scriptPromise;
  function loadScript() {
    if (window.hbspt?.forms?.create) return Promise.resolve();
    if (scriptPromise) return scriptPromise;
    scriptPromise = new Promise((resolve, reject) => {
      let script = document.querySelector('script[src*="js.hsforms.net/forms/embed/v2.js"]');
      const owned = !script;
      if (!script) { script = document.createElement('script'); script.src = 'https://js.hsforms.net/forms/embed/v2.js'; script.async = true; }
      const timer = setTimeout(() => finish(false), 20000);
      function finish(ok) {
        clearTimeout(timer); script.removeEventListener('load', onLoad); script.removeEventListener('error', onError);
        if (ok && window.hbspt?.forms?.create) resolve();
        else { if (owned) script.remove(); reject(new Error('Form script unavailable')); }
      }
      const onLoad = () => finish(true), onError = () => finish(false);
      script.addEventListener('load', onLoad); script.addEventListener('error', onError);
      if (owned) document.head.appendChild(script);
    }).catch(error => { scriptPromise = null; throw error; });
    return scriptPromise;
  }
  function init(scope) {
    const roots = [...scope.querySelectorAll('[data-trade-gate]')];
    if (scope.matches?.('[data-trade-gate]')) roots.unshift(scope);
    roots.forEach(root => {
      const target = root.querySelector('[data-form-target]');
      if (!target || root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      const status = root.querySelector('[data-status]'), retry = root.querySelector('[data-retry]');
      let generation = 0;
      function render() {
        const current = ++generation;
        status.hidden = false; status.textContent = 'Loading form…'; retry.hidden = true;
        let readyTimer;
        const fail = () => { if (current !== generation || !root.isConnected) return; status.hidden = false; status.textContent = 'The form could not load. Please retry or refresh this page.'; retry.hidden = false; };
        loadScript().then(() => {
          if (!root.isConnected || current !== generation) return;
          target.replaceChildren();
          readyTimer = setTimeout(fail, 20000);
          window.hbspt.forms.create({
            portalId: root.dataset.portal, formId: root.dataset.form, region: root.dataset.region,
            target: '#' + target.id,
            cssClass: 'sw-trade-form',
            css: '.hs-form{font-family:Arial,sans-serif;color:#222}.hs-form-field{margin-bottom:19px}label{font-size:14px;font-weight:600;display:block;margin-bottom:7px}.hs-input:not([type=checkbox]):not([type=radio]){width:100%!important;box-sizing:border-box;background:#fff;color:#222;border:1px solid #b7b7b7;border-radius:3px;padding:12px;font-size:16px;line-height:1.4}fieldset{max-width:100%!important}.input{margin-right:0!important}.hs-button{background:#262626;color:#fff;padding:14px 22px;border:1px solid #262626;border-radius:3px;font-size:16px;font-weight:600;cursor:pointer}.hs-error-msgs{color:#a32222;list-style:none;padding:0;font-size:13px}.legal-consent-container{font-size:13px;line-height:1.5}input:focus-visible,select:focus-visible,textarea:focus-visible{outline:2px solid #555;outline-offset:2px}input[type=checkbox],input[type=radio]{width:auto!important}textarea{min-height:100px}',
            onFormReady: () => { clearTimeout(readyTimer); if (current !== generation || !root.isConnected) return; status.hidden = true; retry.hidden = true; },
            onFormSubmitted: () => {
              clearTimeout(readyTimer);
              if (current !== generation || !root.isConnected) return;
              root.querySelector('[data-form-panel]').hidden = true;
              const success = root.querySelector('[data-success]'); success.hidden = false; success.focus();
            }
          });
        }).catch(() => { clearTimeout(readyTimer); fail(); });
      }
      retry.addEventListener('click', render); render();
    });
  }
  window.swTradeshowGate = { init };
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
